"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.logger = void 0;
var logger_1 = __importDefault(require("./logger"));
var console_1 = __importDefault(require("./logger/transport/console"));
var console_2 = __importDefault(require("./logger/capturer/console"));
var types_1 = require("./logger/types");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return types_1.LogLevel; } });
var logger = new logger_1.default({
    loggerTransports: [new console_1.default()],
    exceptionCapturers: [new console_2.default()]
});
exports.logger = logger;
var init = function (config) {
    logger.setConfig(config.logger);
};
exports.default = init;
